// extracted by mini-css-extract-plugin
export default {"button":"GoTopButton__button--46B","cookiesIsBottom":"GoTopButton__cookiesIsBottom--1J4"};